import * as actionTypes from '../actions/actionsTypes';

const initialState = {
    initialFinishRaceEntrantsList: {
    data: []
  },
};

export const initialFinishRaceEntrantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_INITIAL_FINISH_RACE_ENTRANTS:
      return {
        ...state,
        initialFinishRaceEntrantsList: action.payload,
      };
    default:
      return state;
  }
};
